var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
//import { ResponsivePie } from '@nivo/pie'
import { ResponsivePie } from './pie';

import "./ChartLine.scss";

import PieTooltip from "./ChartPieTooltip";
import PieLegend from "./ChartPieLegend";

var ChartPie = (_temp2 = _class = function (_Component) {
    _inherits(ChartPie, _Component);

    function ChartPie() {
        var _temp, _this, _ret;

        _classCallCheck(this, ChartPie);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getProps = function () {
            var renderTooltip = _this.props.renderTooltip;


            return _extends({}, _this.props);
        }, _this.renderTooltip = function (slice) {
            var _this$props = _this.props,
                data = _this$props.data,
                colors = _this$props.colors;


            if (_this.props.renderTooltip) {
                return _this.props.renderTooltip({ data: data, colors: colors, slice: slice });
            }

            return React.createElement(PieTooltip, _extends({}, _this.props, { slice: slice }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    ChartPie.prototype.render = function render() {
        var props = this.getProps();

        return React.createElement(ResponsivePie, props);
    };

    return ChartPie;
}(Component), _class.defaultProps = {
    data: [],
    theme: {},

    innerRadius: 0.25,
    padAngle: 1,

    cornerRadius: 0,
    borderWidth: 0,

    enableRadialLabels: false,
    enableSlicesLabels: false,

    sortByValue: false,

    margin: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    },

    animate: false,
    isInteractive: true

}, _temp2);


export default ChartPie;